import {Page} from '@vio/core/src/analytics/types/Events'
import {META_TRAFFIC_PROFILE} from '@vio/core/src/profile/constants'

export const getIsPageBoVioEligible = (pageName: Page): boolean => {
  return [Page.Search, Page.Accommodation].includes(pageName)
}
export interface checkIsBovioEnvironmentParams {
  pageName: Page
  hidesAppLockedDeals: boolean
  brandIsOtaMode?: boolean
  profileParam: string
}

export const checkIsBovioEnvironmentEligible = ({
  pageName,
  hidesAppLockedDeals,
  brandIsOtaMode = false,
  profileParam
}: checkIsBovioEnvironmentParams) => {
  const isPageBoVioEligible = getIsPageBoVioEligible(pageName)
  // Check all conditions before firing the toggle()

  // 1. Brand must have a BoVio environment or be in OTA mode, and page is SRP or AP
  if ((!hidesAppLockedDeals && !brandIsOtaMode) || !isPageBoVioEligible)
    return false
  // 2. Excluding meta traffic
  if (profileParam && profileParam === META_TRAFFIC_PROFILE) return false

  return true
}
